// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const OR = "nebo";
export const SOCIAL_LOGIN_WITH_FACEBOOK = "Pokra\u010duj s Facebook";
export const SOCIAL_LOGIN_WITH_GOOGLE = "Pokra\u010duj s Google";
export const SOCIAL_LOGIN_WITH_MOJEID = "Pokra\u010duj s mojeID";
export const SOCIAL_SIGNUP_WITH_FACEBOOK = "Pokra\u010duj s Facebook";
export const SOCIAL_SIGNUP_WITH_GOOGLE = "Pokra\u010duj s Google";
export const SOCIAL_SIGNUP_WITH_MOJEID = "Pokra\u010duj s mojeID";
